const hasUpperlowerCase = val =>
   /^[a-zA-Z0-9!@#$%^&*()\-_=+\\|;:'",.<>/?]*[a-zA-Z][a-zA-Z0-9!@#$%^&*()\-_=+\\|;:'",.<>/?]*$/.test(val); //eslint-disable-line
const hasNumberPhone = val => /^[\d\(\)\-\+]{10,20}$/.test(val); //eslint-disable-line
const hasEmail = (
   val, //eslint-disable-line
) => /^(?!-)(?!.*--)[A-Za-z0-9!#$%&‘*+=?^_`{|}~.-]+(?<!-)(?<!-)@(?!-)(?!.*--)[A-Za-z0-9.-]+(?<!-)(?<!-)$/.test(val); //eslint-disable-line
const hasPassword = val => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*()\-_=+\\|;:'",.<>/?]*$/.test(val); //eslint-disable-line
const hasEightDigitCode = val => /^\d{8}$/.test(val); //eslint-disable-line

// NEW: E.164 phone validator
// +[1-9][0-9]{7,14} →  min 8 digits (including country code) max 15 digits
const hasPhoneE164 = val => {
   if (!val) return true; //   allow empty values
   const trimmed = String(val).trim();
   const E164_REGEX = /^\+[1-9]\d{7,14}$/;
   return E164_REGEX.test(trimmed);
};

export { hasNumberPhone, hasPassword, hasUpperlowerCase, hasEmail, hasEightDigitCode, hasPhoneE164 };
